<template>
		<div class="container">
		    <div v-show="loading" class="loading">
		      <i  class="fa fa-3x fa-spinner fa-spin"></i>
		    </div>
      <header class="topbar bd-navbar clearfix" style="padding-top: 0px !important; box-shadow: 0 2px 0px rgba(0, 0, 0, 0.16); !important; background-color: #17bab8">
        <div class="container">
          <div class="row" style="padding-right: 5px; padding-left: 5px;">
            <div class="col-md-2">
              <router-link to="/" style="text-decoration: none;"><h3 style="color: #ffffff; margin-top: 15px; text-decoration: none;">< Back</h3></router-link>
            </div>
            <div class="col-md-8">
              <h3 style="color: #ffffff; margin-top: 15px; text-decoration: none;">License & Download</h3>
            </div>
            <div class="col-md-2">
            </div>
          </div>
        </div>
      </header>
			<div class="row">
				<div class="col-md-12">
<!--				<router-link to="/"><button class="btn btn-primary pull-left" style="border-radius:0px;box-shadow:0px;">Back to your products</button></router-link>-->

					<div class="widget-wrap">

						<div class="widget-container margin-top-0">

							<div class="widget-content">

								<div style="clear:both; float:none; margin-bottom:30px;"></div>
								<div class="row">
									<div class="col-md-4">
										<img v-if="item.image" :src="item.image" class="img-responsive" style="padding:15px">
										<img v-else src="static/images/product_placeholder.png" class="img-responsive" style="padding:15px">
									</div>
									<div class="col-md-8">
										<h1 style="text-align:left; margin-top:10px;"><b>{{item.ProductName}}</b></h1>
										<p style="text-align:left;" v-html="item.description"></p>
                    <button v-if="item.license_type=='FREE'" @click="addToCart(buy[0])" class="btn btn-danger avangate_button" style="width: 100%; height: 40px;">
                      <span>BUY NOW <small>({{ parseInt(buy[0].price) }} {{ buy[0].currency }})</small></span>
                    </button>
									</div>
								</div>

								<div class="row j-forms" v-if="deactivated">
									<div class="col-md-12">
										<div class="success-message">
											<p>Key deactivated successfully</p>
										</div>
									</div>
								</div>

								<div class="row downloads">
                  
									<div class="col-md-12" v-if="!item.discontinued || item.discontinued == 0">
										<h3 style="text-align:left"><b>Download, Install and Manage Updates</b></h3>
                    <p class="text-left">If you haven't done it yet, download and install the "<b>Audio Modeling Software Center</b>" that is all you need to install and authorize all your products at the same time and check for new versions and updates.</p>
										<hr>
                    <span style="display:block; margin-bottom:15px">
                        <div class="row line">
                          <div class="btn-group">
                            <a href="https://audiomodeling.com/support/install-and-update" target="_blank"><button class="btn btn-primary btn-spaziami btn-lg">Download AM Software Center</button></a>
                          </div>
                        </div>
                    </span>
                    <p class="text-left">If you already have the Audiom Modeling Software Center, run it to install the new purchases or update your current products.</p>
									</div>
                  <div class="col-md-12" v-else style="display:block; margin-bottom:15px">
                    <h3 style="text-align:left"><b>Downloads</b></h3>
                    <hr>
									  <div class="unit">
  										<div class="col-sm-4">
  											<div class="row title"><h4><i class="zmdi zmdi-apple"></i> Apple OS X</h4></div>
  											<span v-for="file in downloads.downloads" >
  												<div class="row line" v-if="file.operating_system == 'Windows/Mac OSX' || file.operating_system == 'Mac OSX'">
  													<div class="btn-group">
  														<button class="btn btn-primary btn-spaziami" @click="getToken(file.id_file,file)">v{{file.version}} {{file.architecture}} <i class="zmdi zmdi-download"></i></button>
  													</div>
  												</div>
  											</span>
  										</div>
  										<div class="col-sm-4">
  											<div class="row title"><h4><i class="zmdi zmdi-windows"></i> Microsoft Windows</h4></div>
  											<span v-for="file in downloads.downloads" >
  												<div class="row line" v-if="file.operating_system == 'Windows/Mac OSX' || file.operating_system == 'Windows'">
  													<div class="btn-group">
  														<button class="btn btn-primary btn-spaziami" @click="getToken(file.id_file,file)">v{{file.version}} {{file.architecture}} <i class="zmdi zmdi-download"></i></button>
  													</div>
  												</div>
  											</span>
  										</div>
  										<div class="col-sm-4">
  											<p>{{item.download_notes}}</p>
  										</div>
  									</div>
                  </div>
								</div>

								<div class="row">
									<div v-if="otherDownloads.length != 0" class="col-sm-12">
											<h3 style="text-align:left;"><b>Manuals and additional files</b></h3>
											<hr>
											<span v-for="file in otherDownloads" style="display:block; margin-bottom:15px">
												<div class="row line">
													<div class="btn-group">
														<a v-bind:href="file.filepath" target="_blank"><button class="btn btn-primary btn-spaziami">{{file.filename}} <i class="zmdi zmdi-download"></i></button></a>
													</div>
												</div>
											</span>
                  </div>
								</div>

                <div class="row" v-if="item.license_type != 'FREE'">
                  <div class="col-md-12">
                    <h3 style="text-align:left; margin-top:50px"><b>Manage your license activations</b></h3>
                    <hr>
                  </div>
                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-xs-6"><h4>Key</h4></div>
                      <div class="col-xs-2">
                        <h4 class="hidden-xs">Valid until</h4>
                        <h4 class="visible-xs">Expire</h4>
                      </div>
                      <div class="col-xs-2">
                        <h4 class="hidden-xs">Max Activations</h4>
                        <h4 class="visible-xs">Max Activ.</h4>
                      </div>
                      <div class="col-xs-2">
                        <h4 class="hidden-xs">Left Activations</h4>
                        <h4 class="visible-xs">Left Activ.</h4>
                      </div>
                    </div>

                    <div class="panel-group" id="keys" >
                      <div class="panel panel-default purchase" v-for="mykey, myindex in mykeys">

                        <div class="row">
                          <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#keys" v-bind:href="'#key_'+myindex" aria-expanded="true" v-bind:aria-controls="'key_'+myindex">
                            <div class="panel-heading btn-primary" role="tab">
                              <h4 class="panel-title">
                                <div class="row">
                                  <div class="col-xs-6"><p>{{ mykey.key }}</p></div>
                                  <div class="col-xs-2"><p v-if="mykey.valid_until">{{ mykey.valid_until.substring(0,10) }}</p></div>
                                  <div class="col-xs-2"><p>{{ mykey.max_activations }}</p></div>
                                  <div class="col-xs-2"><p>{{ mykey.left_activations }}</p></div>
                                </div>
                              </h4>
                            </div>
                          </a>

                          <div class="panel-collapse collapse" v-bind:id="'key_'+myindex">
                            <div class="panel-body">
                              <div v-if="mykey.activations">
                                <div class="inside-me" style="padding-top:15px; padding-bottom:15px; border-bottom:0px;">
                                  <button type="button" class="btn btn-sm btn-info"
                                          v-clipboard:copy="mykey.key"
                                          v-clipboard:success="onCopy"
                                          v-clipboard:error="onError">Copy License Key to Clipboard</button>
                                  <button type="button" v-if="item.offline_allowed==1" v-on:click="showModalOffline=true; code1=mykey.key" class="btn btn-sm btn-info">Offline Activation</button>

                                </div>
                                <table class="table table-striped">
                                  <thead>
                                  <tr role="row">
                                    <th>Activation Code</th>
                                    <th>Activation Date</th>
                                    <th>O.S.</th>
                                    <th>Label/Seat</th>
                                    <th>Action</th>
                                  </tr>
                                  </thead>
                                  <tbody>

                                  <tr role="row products" v-for="activation in mykey.activations">
                                    <td class="hidden-xs">{{ activation.license }}</td>
                                    <td class="visible-xs"><button class="btn btn-primary" v-on:click="show(activation.license)"><i class="zmdi zmdi-key"></i></button></td>
                                    <td>{{ activation.date }}</td>
                                    <td>{{ activation.os_name }} {{ activation.os_arch }}</td>
                                    <td>{{ activation.label }}</td>
                                    <td><button type="button" v-if="activation.mode!='offline'" class="btn btn-danger" v-on:click="deactivate(activation.id)">DEAUTHORIZE</button>
                                      <button type="button" v-if="activation.mode=='offline'" class="btn btn-danger" v-on:click="offline()">OFFLINE</button></td>
                                  </tr>

                                  </tbody>
                                </table>
                              </div>

                              <div v-else class="inside-me">
                                <button type="button" class="btn btn-sm btn-info"
                                        v-clipboard:copy="mykey.key"
                                        v-clipboard:success="onCopy"
                                        v-clipboard:error="onError">Copy License Key to Clipboard</button>
                                <button type="button" v-if="item.offline_allowed==1" v-on:click="showModalOffline=true; code1=mykey.key" class="btn btn-sm btn-info">Offline Activation</button>
                                <p>There are no authorizations for this key, yet</p>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

								<div class="row" v-if="item.license_type != 'FREE'">
              	<div class="col-md-12">
					<h3 style="text-align:left;"><b>Purchase transactions</b></h3>
					<hr>
				</div>
                <div class="col-md-12">

                  <!-- Trasaction -->
                  <div class="row">
                    <div class="col-md-12">
                      <div class="row hidden-xs">
                        <div class="col-sm-3 hidden-xs"><h4>Status & Date</h4></div>
                        <div class="col-sm-3"><h4>Purchase ID & Date</h4></div>
                        <div class="col-sm-3 hidden-xs"><h4>Purchase email</h4></div>
                        <div class="col-sm-3 hidden-xs"><h4>Products</h4></div>
                      </div>

                      <div class="panel-group" id="orders">
                        <div class="panel panel-default purchase" v-for="purchase, key in myorders" v-if="current_orders.includes(purchase.id)">
                          <div class="row" >
                            <a class="accordion-toggle collapsed" data-toggle="collapse" data-parent="#orders" v-bind:href="'#pur_'+purchase.id" aria-expanded="true" v-bind:aria-controls="'pur_'+purchase.id">

                              <div class="panel-heading btn-primary" role="tab">
                                <h4 class="panel-title">
                                  <div class="row">
                                    <div class="col-sm-3 purchase hidden-xs">
                                      <p>
                                        <span v-if="purchase.validated">Purchase confirmed</span>
                                        <span v-if="!purchase.validated">Waiting for confirmation</span><br/>
                                        <small>{{ purchase.last_validate }} GMT</small>
                                      </p>
                                    </div>
                                    <div class="visible-xs-block col-xs-12">
                                      <p>{{ purchase.PurchaseId }}<br/><small>{{ purchase.PurchaseDate }} GMT</small><br/>{{ purchase.BillingContactEmail }}</p>
                                    </div>
                                    <div class="col-sm-3 purchase hidden-xs"><p>{{ purchase.PurchaseId }}<br/><small>{{ purchase.PurchaseDate }} GMT</small><span class="visible-xs-block"><br/>{{ purchase.BillingContactEmail }}</span></p></div>
                                    <div class="col-sm-3 purchase hidden-xs"><p>{{ purchase.BillingContactEmail }}</p></div>
                                    <!--<div class="col-xs-6 contact"><p>{{ purchase.BillingContactFirstName }} {{ purchase.BillingContactLastName }}</p></div>-->
                                    <div class="col-sm-3 products hidden-xs"><p>{{ purchase.total_products }}</p></div>
                                  </div>
                                </h4>
                              </div>

                            </a>

                            <div class="panel-collapse collapse" v-bind:id="'pur_'+purchase.id">
                              <div class="panel-body">
                                <div class="inside-me" style="padding-top:15px; padding-bottom:15px; border-bottom:0px;" v-if="purchase.products.length > 0">
                                  <button v-if="!purchase.validated" class="btn btn-sm btn-info" @click="sendEmail(purchase)">Resend confirmation email</button>
                                </div>
                                <div class="inside-me" style="padding-top:15px; padding-bottom:15px;" v-if="purchase.products.length == 0">
                                  <button v-if="!purchase.validated" class="btn btn-sm btn-info" @click="sendEmail(purchase)">Resend confirmation email</button>
                                </div>

                                <span class="visible-xs-block inside-xs">
                                  <p>
                                    <span v-if="purchase.validated">Purchase confirmed</span>
                                    <span v-if="!purchase.validated">Waiting for confirmation</span><br/>
                                    {{ purchase.last_validate }} GMT
                                  </p>
                                </span>

                                <table class="table table-striped" v-if="purchase.products.length > 0">
                                  <thead>
                                    <tr role="row">
                                      <th>Product <span class="hidden-xs">name</span></th>
                                      <th>Price</th>
                                    </tr>
                                  </thead>
                                  <tbody>

                                    <tr role="row products" v-for="product, indice in purchase.products">
                                      <td>{{ product.ProductName }}</td>
                                      <td v-if="product.total">{{ product.total }}</td>
                                      <td v-if="!product.total"></td>
                                    </tr>

                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!--<div class="col-md-12">
                        <button class="btn btn-default btn-lg" @click="addOrder()" type="button"><i class="zmdi zmdi-collection-plus"></i> Register a new product</button>
                      </div>-->
                    </div>
                  </div>
                </div>
              </div>


							</div>
						</div>
					</div>
				</div>
			</div>

			<modal :showModal="showModalOffline" :closeAction="closeSourceDialog" :containerClass="'offline'">
			  <h3 slot="header">Offline Activation</h3>

			  <div class="row form-content" slot="body">

                        <div class="col-md-12" v-if="errorsActivation!=''">
						  	<div class="alert alert-danger" role="alert">
			                            <p>{{errorsActivation}}</p>
			                </div>
			            </div>

			  	<div class="col-md-12 form-group">
			  		<p style="font-size:93%">Please, type the System-ID reported on the Offline Activation Window of your SWAM product.</p>
			  	</div>
			  	<div class="col-md-12 form-group">
			  		<input type="text" class="form-control" name="code1" v-model="code1" disabled="true">
			  	</div>
			  	<div class="col-md-12 form-group">
			  		<input type="text" class="form-control" placeholder="System-ID" name="code2" v-model="code2">
			  	</div>
			  	<div class="col-md-12 form-group">
			  		<input type="text" class="form-control" placeholder="Label/Seat" name="label" v-model="label">
			  	</div>
			  	<div class="col-md-12 form-group">
			  		<button type="button" class="btn btn-primary" v-on:click="offlineActivation(item)">Submit</button>
			  	</div>
			  </div>
			</modal>
			<script v-html="jsonld" type="application/ld+json"></script>
		</div>

	</template>
	<script>
		import auth from '../auth'
		import Modal from 'modal-vue'
		export default {
			components: { Modal },
			data(){
				return{
					loading:false,
					deactivated: false,
					get transactions(){
						if(localStorage.getItem('userhome')=='transaction')
							{
								return true
							}else{
								return false
							}
					},
					get reseller(){
						return localStorage.getItem('reseller')
					},
					get downloads(){
						return JSON.parse(localStorage.getItem('downloads')) || 0;
					},
					get otherDownloads(){
						// al momento non gestisco il "type" dei vari file
						return JSON.parse(localStorage.getItem('other_downloads')) || 0;
					},
					get utente(){
			          return JSON.parse(localStorage.getItem('userdata')) || 0;
			        },
			        get current_orders(){
			        	return localStorage.getItem('current_orders')
			        },
					get getOrders(){
					     var user_id = this.utente.id
						 auth.getOrders(this, user_id, this.mycompany)
					},
					get orderid(){
					    return localStorage.getItem('orderid')
					},
					get item(){
					    return JSON.parse(localStorage.getItem('item')) || 0;
					},
					get jsonld(){
						const jsonld = {
						  "@context": "https://www.schema.org",
						  "@type": "product",
						  "brand": "Audiomodeling",
						  "logo": "https://my.audiomodeling.com/static/images/logo-am.png",
						  "name": this.item.ProductName,
						  "category": this.item.family,
						  "image": this.item.image,
						  "description": this.item.description
						}

						return jsonld
					},
					showModalOffline: false,
					errorsActivation: '',
					code1: '',
					code2: '',
					label: '',
					method: '',
					user_id: '',
					other_downloads: '',
					mycompany: '',
					company: '',
					myorders: [],
					mykeys: JSON.parse(localStorage.getItem('mykeys')) || 0,
          catalog: JSON.parse(localStorage.getItem('catalog')) || [],
          buy: []
				}
			},
			mounted(){
				document.body.scrollTop = document.documentElement.scrollTop = 0;
				this.getOrders

				window.fbq('trackCustom','ManageProduct', {
				  product: this.item.ProductName,
				  family: this.item.family
				});

        this.getBuyItem();
			},
			async created(){
		      this.loading = true
		      this.companies = auth.getCompany(this)
		    },
			methods: {
        addToCart(product){
         window['TwoCoInlineCart'].products.removeAll();
       // window['TwoCoInlineCart'].cart.setCurrency(product.currency);
        window['TwoCoInlineCart'].products.add({
            code: product.code,
            quantity: 1,
            //price: product.price
        });
        //console.log('products',window['TwoCoInlineCart'].products.list)
        //window['TwoCoInlineCart'].cart.setAutoAdvance(true);
        window['TwoCoInlineCart'].cart.checkout();

        //this.$root.cart = window['TwoCoInlineCart'].products.list;
      },
        getBuyItem(){
          this.buy = this.catalog.filter(obj => {
            return obj.id === this.item.id
          })
        },
				getToken(id_file,file){
					window.fbq('trackCustom', 'Download', { platform: file.operating_system, version: file.version, architecture: file.architecture, product: this.item.ProductName, family: this.item.family })
					var token_min = process.env.TOKEN_DURATION
					auth.getToken(this, id_file, token_min, this.item.license_type)
				},
				closeSourceDialog(){
					this.showModalOffline = false
				},
				async offlineActivation(item){
					var user_id = this.utente.id
			          if (localStorage.getItem('reseller')==0 || localStorage.getItem('reseller')=='undefined'){
			            var company = this.companies[0].id

			          }else{
			            var company = localStorage.getItem('reseller')
			          }
					/*auth.getOrders(this,user_id, company)*/
					this.loading = true
					let promise = new Promise((res, rej) => {
						auth.activate(this,item)
					});

					let result = await promise;
				},
				deactivate(id){
					var context = this
					bootbox.confirm('<b>Key Deactivation</b><br>Are you sure?', function(result){
						context.showModalOffline = false
						if(result){
							auth.deactivate(context, id)
						}
					});
				},
				show(mycode){
					bootbox.alert('Your activation code is<br/> '+mycode);
				},
				offline(){
					bootbox.alert('OFFLINE authorization - contact support for deauthorization');
				},
				onCopy: function (e) {
			      alert('You just copied: ' + e.text)
			      },
			      onError: function (e) {
			        alert('Failed to copy text')
			      }
			}
		}
	</script>



// WEBPACK FOOTER //
// src/components/Keys.vue